import React from 'react';
import styled from 'styled-components';
import { NoiseLimitTable } from './limits/NoiseLimitTable';
import { DustLimitTable } from './limits/DustLimitTable';
import { WeatherLimitTable } from './limits/WeatherLimitTable';
import { VibraLimitTable } from './limits/VibraLimitTable';
import { Xv2pLimitTable } from './limits/Xv2pLimitTable';

const StyledLimits = styled.div`
  width: 100%;
`;

export const Limits = ({ type_id, subtype_id, limits }: { type_id: any; subtype_id: any; limits: any; }) => {
  
  const LimitComponent = limit_component_lookup[type_id][subtype_id];
  console.log(limits)
  return (
    <StyledLimits>
      <LimitComponent limits={limits}/>
    </StyledLimits>
  )
}

const limit_component_lookup = {
  1: {
    0: NoiseLimitTable,
    1: NoiseLimitTable
  },
  2: {
    0: VibraLimitTable,
    1: Xv2pLimitTable,
    2: Xv2pLimitTable,
    3: Xv2pLimitTable,
    4: Xv2pLimitTable
  },
  3: {
    0: DustLimitTable,
    1: DustLimitTable
  },
  4: {
    0: WeatherLimitTable
  }
}

